module.exports = __webpack_public_path__ + "static/media/20200811_182024.7f782ca0.webp";